(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /* Ator fix: hero buttons such as "Discover the collection" use a fixed section ID that breaks whenever the
     theme is copied. If that ID is not on the page, scroll to the product list instead. */
  document.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest('a[href^="#shopify-section-template--"]');
    if (!link) return;
    const hash = link.getAttribute('href');
    if (document.getElementById(hash.slice(1))) return;
    const target = document.getElementById('ResultsList');
    if (!target) return;
    event.preventDefault();
    target.style.scrollMarginTop = '90px';
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();
})();
